import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AlertTriangle, Home, ArrowLeft, Clock } from "lucide-react";
import { Button } from "../components/ui/button";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0f] via-[#0d0d14] to-[#0a0a0f] flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Icon */}
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto bg-red-500/10 rounded-full flex items-center justify-center mb-6 animate-pulse">
            <AlertTriangle className="h-12 w-12 text-red-500" />
          </div>
          <h1 className="text-8xl font-chivo font-black text-white mb-2">404</h1>
          <h2 className="text-2xl font-bold text-zinc-300">Sayfa Bulunamadı</h2>
        </div>

        {/* Message */}
        <p className="text-zinc-400 mb-8">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>

        {/* Countdown */}
        <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 mb-8">
          <div className="flex items-center justify-center gap-2 text-zinc-400 mb-2">
            <Clock className="h-5 w-5 text-amber-400" />
            <span>Ana sayfaya yönlendiriliyorsunuz</span>
          </div>
          <div className="text-4xl font-chivo font-black text-emerald-400">
            {countdown}
          </div>
          <div className="text-sm text-zinc-500">saniye</div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="border-zinc-700 text-zinc-300 hover:bg-zinc-800"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Geri Dön
          </Button>
          <Link to="/">
            <Button className="bg-emerald-600 hover:bg-emerald-500 text-white w-full sm:w-auto">
              <Home className="h-4 w-4 mr-2" />
              Ana Sayfa
            </Button>
          </Link>
        </div>

        {/* Footer */}
        <p className="text-xs text-zinc-600 mt-12">
          Hata kodu: 404 | Sayfa bulunamadı
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
